module.exports = __webpack_public_path__ + "LAPTOPVIEW-185aa205.webp";